import { PAYPRO_CASE_NOTE_ACTIONS } from "constants/actions";

export function fetchPayProCaseNotes(action_details_id) {
    console.log("UNDER ACTION", action_details_id);
    return {
        type: PAYPRO_CASE_NOTE_ACTIONS.FETCH_PAYPRO_CASE_NOTES,
        payload: {
            action_details_id
        }
    };
}
export function fetchedPayProCaseNotes(action_details_id, data) {
    return {
        type: PAYPRO_CASE_NOTE_ACTIONS.FETCHED_PAYPRO_CASE_NOTES,
        payload: {
            action_details_id,
            data
        }
    };
}

export function failedFetchPayProCaseNotes(action_details_id, error) {
    return {
        type: PAYPRO_CASE_NOTE_ACTIONS.FAILED_FETCH_PAYPRO_CASE_NOTES,
        payload: {
            action_details_id
        },
        error
    };
}